export const revalidate = process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 60 : 1;

// determine publication mode. If true publish domain page at root rather than index file.
export const publishMode = process.env.NEXT_PUBLIC_PUBLISHED === 'true';
export const domain = process.env.NEXT_PUBLIC_PUBLISHED_DOMAIN_ID;

/** Builder.io published-domain ID of the vince-testing project (also set in CI + lighthouse workflows). */
export const TEST_PUBLISHED_DOMAIN_ID = 'e03a0a82de4f4e81941c522b8fae27be';
export const isTestDomain = domain === TEST_PUBLISHED_DOMAIN_ID;

export const fallback = 'blocking';
